import { useCallback } from 'react';
import { isEmpty } from 'ramda';
import { useSpecificPageLink } from './useSpecificPageLink';

export const useSelectSpecificSEOData = () => {
  const specificPageLink = useSpecificPageLink();

  return useCallback(
    (data) => {
      if (!specificPageLink) return data;

      const specificSEOData = data.filter(
        (item) => item.pagelink.name === specificPageLink
      );

      if (isEmpty(specificSEOData)) {
        return data;
      }

      return specificSEOData;
    },
    [specificPageLink]
  );
};
